import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faUserClock, faClock } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import BB from './images/BB.png';
import Clock from './images/Clock.png';

function NotApproved() {
    const navigate = useNavigate();
    
    const HandleOK = async () => {
        try {
            await fetch(`${process.env.REACT_APP_FORE_APILINK}/user/user-logout`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-token': sessionStorage.getItem('token')
                }
            });
            // Clear storage and redirect
            localStorage.removeItem('userData');
            sessionStorage.clear();
            navigate('/consumer');
                   
        } catch (error) {
            console.error('Error during logout:', error);
            // Still clear storage and redirect on error
            localStorage.removeItem('userData');
            sessionStorage.clear();
            navigate('/consumer');
        }
    };

    return (
       <div className='flex flex-col items-center w-full min-h-screen relative'>
           
           {/* Top div with logo and user image with diagonal division - increased height */}
             {/* Gray background for right side */}
             {/* <div className="absolute top-0 right-0 w-full h-full bg-gray-100"
                  style={{
                    clipPath: 'polygon(100% 0, 100% 100%, 0 100%)'
                  }}>
             </div>
              */}
             {/* Content container */}
             {/* <div className="relative flex justify-between items-center w-full h-full px-4 z-10">
               <div className="w-1/4 flex flex-col">
                 <img src={BB} alt="Brickbucket Logo" className="h-15 w-15 mb-20" />
               </div>
               <div className="w-1/3 flex flex-col items-end mt-10">
                 <div className="h-20 w-20 flex items-center justify-center">
                   <FontAwesomeIcon 
                     icon={faUserClock} 
                     className="text-gray-600 h-16 w-16" 
                   />
                 </div>
          <h1 className="text-black text-md font-semibold whitespace-nowrap mt-2 mr-3">Brickbucket</h1>
<h2 className="text-black text-xl font-bold whitespace-nowrap">Verification</h2>


               </div>
             </div> */}

<div className="relative w-full md:w-2/3 h-18 mb-24 py-2 mt-2 overflow-hidden border-b border-gray-200 bg-white">
  <div className="flex w-full h-full items-center justify-between z-10 px-1">
    <img src={BB} alt="Brickbucket Logo" className="h-16 w-16 object-contain " />
    <div className="flex items-center">
      <FontAwesomeIcon icon={faUserClock} alt="User Clock" className=" text-gray-600 h-14 w-14 object-contain mr-3" />
      <div>
        <div className="text-[#000000] text-md font-semibold leading-tight mr-3">Brickbucket</div>
        <div className="text-[#000000] text-xl font-bold leading-tight mr-3">Verification</div>
      </div>
    </div>
  </div>
</div>

           {/* Main content */}
           <div className="flex flex-col w-full max-w-md mx-auto px-4">
               {/* Status card with improved design */}
               <div className="bg-white rounded-lg shadow-md w-full mb-4 overflow-hidden">
                   {/* Header */}
                   <div className="bg-[#FFF8F8] p-4 border-b border-[#FFF8F8]">
                     <div className="flex items-center">
                       <div className="rounded-full p-1 mr-0.1">
                         <img src={Clock} alt="Clock" className="h-10 w-10" />
                       </div>
                       <h2 className="text-lg font-semibold text-[#000000]">Approval Pending</h2>
                     </div>
                   </div>
                   
                   {/* Message body */}
                   <div className="p-6">
                       <p className="text-[#000000] item-start mb-6">
Information submitted by you will be verified and approved once we go live shortly. We will notify you accordingly.
                       </p>
                       
                   </div>
               </div>
           </div>

           {/* Fixed button at bottom */}
           <div className="fixed bottom-0 left-0 right-0 p-4 bg-white shadow-lg border-t border-gray-200">
               <button
                   className="bg-[#D64541] text-white rounded-md px-8 py-3 font-semibold transition duration-300 shadow-md hover:bg-red-700 w-full"
                   onClick={HandleOK}>
                   Return to Login
               </button>
           </div>
       </div>
    );
}

export default NotApproved;
